import { createContext, useReducer, useEffect, useState } from "react";
import Cookies from 'js-cookie';


// Context for Theme
export const themeContext = createContext();
var initialState;

const hasDarkModeCookie = Cookies.get('user_setting_dark_mode');
if(hasDarkModeCookie){
  initialState = { darkMode: Cookies.get('user_setting_dark_mode') === 'true' };
  console.log("DarkMode has been set using cookie, dark mode is " + initialState.darkMode + ". Enjoy! :)");
} else {
  // Automatically enable dark mode if user has dark mode enabled in system/broswer
  const systemInDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
if(systemInDarkMode ){
  initialState = { darkMode: true };
  console.log("DarkMode has been enabled so that it aligns with your system settings. Enjoy! :)");
} else {
  const currentHour =  new Date().getHours();
  initialState = (currentHour < 8 || currentHour > 17) ? { darkMode: true } : { darkMode: false };
  console.log("currentHour is " + currentHour + ", so darkMode is " + initialState.darkMode + ". Enjoy! :)");
}}



const themeReducer = (state, action) => {
  switch (action.type) {
    case "toggle":
        return { darkMode: !state.darkMode };
      default:
        return state;
  }
};

export const ThemeProvider = (props) => {
  const [state, dispatch] = useReducer(themeReducer, initialState);
  return (
    <themeContext.Provider value={{state, dispatch}}>{props.children}</themeContext.Provider>
  );
};



// Context for loading status
export const loadingContext = createContext();

var loadingState = { isLoading: false };

const loadingStateReducer = (state, action) => {
  switch (action.type) {
    case "on":
        return { isLoading: true };
      default:
        return { isLoading: false };;
  }
};

export const LoadingStateProvider = (props) => {
  const [state, dispatch] = useReducer(loadingStateReducer, loadingState);
  return (
    <loadingContext.Provider value={{state, dispatch}}>{props.children}</loadingContext.Provider>
  );
};


export const loginContext = createContext();
const NODE_SERVER_BASE_URL = 'https://eai.lmc.gatech.edu/app';

const loginState = {
  isLoggedIn: false,
  jwtToken: null,
  username: null,
  timestamp: null,
  firstname: null,
  lastname: null,
};

const loginStateReducer = (state, action) => {
  switch (action.type) {
    case "login":
      return {
        ...state,
        isLoggedIn: true,
        jwtToken: action.payload.jwtToken,
        username: action.payload.username,
        timestamp: action.payload.timestamp,
        firstname: action.payload.firstname,
        lastname: action.payload.lastname,
      };
    case "logout":
      return {
        ...state,
        isLoggedIn: false,
        jwtToken: null,
        username: null,
        timestamp: null,
        firstname: null,
        lastname: null,
      };
    default:
      return state;
  }
};

export const LoginStateProvider = (props) => {
  const [state, dispatch] = useReducer(loginStateReducer, loginState);

  useEffect(() => {
    const jwtToken = Cookies.get('jwt_token');
    const username = Cookies.get('username');
    const timestamp = Cookies.get('timestamp');
    const firstname = Cookies.get('firstname');
    const lastname = Cookies.get('lastname');

    if (jwtToken && username) {
      dispatch({
        type: "login",
        payload: { jwtToken, username, timestamp, firstname, lastname }
      });
    }
  }, []);

  const login = async (credentials) => {
    try {
      const response = await fetch(`${NODE_SERVER_BASE_URL}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
      });

      if (!response.ok) {
        throw new Error('Login failed');
      }

      const data = await response.json();

      Cookies.set('jwt_token', data.jwtToken, { expires: 7 });
      Cookies.set('username', data.username, { expires: 7 });
      Cookies.set('timestamp', data.timestamp, { expires: 7 });
      Cookies.set('firstname', data.firstname, { expires: 7 });
      Cookies.set('lastname', data.lastname, { expires: 7 });

      dispatch({
        type: "login",
        payload: {
          jwtToken: data.jwtToken,
          username: data.username,
          timestamp: data.timestamp,
          firstname: data.firstname,
          lastname: data.lastname,
        },
      });
    } catch (error) {
      console.error('Error during login:', error);
    }
  };

  const logout = () => {
    Cookies.remove('jwt_token');
    Cookies.remove('username');
    Cookies.remove('timestamp');
    Cookies.remove('firstname');
    Cookies.remove('lastname');

    dispatch({ type: 'logout' });
  };

  return (
    <loginContext.Provider value={{ state, dispatch, login, logout }}>
      {props.children}
    </loginContext.Provider>
  );
};


// Context for study progress
export const StudyProgressContext = createContext();

export const StudyProgressProvider = ({ children }) => {
  // Default progress starts at 0%
  const [studyProgress, setStudyProgress] = useState(0);

  return (
    <StudyProgressContext.Provider value={{ studyProgress, setStudyProgress }}>
      {children}
    </StudyProgressContext.Provider>
  );
};